/**
 * All of it is a HACK to fix empty paragraph blocks in Slate editor.
 */
import isTextBlock from '@atlas/tool/box/slate/isTextBlock';
import { type Descendant, Element } from 'slate';

export default function fixEmptyChildren(children: Descendant[]): Descendant[] {
    let hasFixes = false;

    const fixedChildren = children.map((child) => {
        if (!Element.isElement(child)) return child;

        if (isTextBlock(child) && child.children.length === 0) {
            hasFixes = true;
            return { ...child, children: [{ text: '' }] };
        }

        return child;
    });

    if (!hasFixes) return children;

    console.error('fixEmptyChildren: fixed empty children in blocks', children);
    return fixedChildren;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('fixEmptyChildren', async () => {
        it('does not affect valid structures', () => {
            expect(fixEmptyChildren([])).toEqual([]);
            expect(fixEmptyChildren([{ type: 'paragraph', children: [{ text: '' }] }])).toEqual([
                { type: 'paragraph', children: [{ text: '' }] },
            ]);
        });

        it('adds empty text node if missing', () => {
            expect(fixEmptyChildren([{ type: 'paragraph', children: [] }])).toEqual([
                { type: 'paragraph', children: [{ text: '' }] },
            ]);
        });
    });
}

// #endregion
